(() => {

    class StickyNavigation {

        constructor(navEl) {
            this.navEl = navEl;
            this.mobileCurrentIndicator = navEl.querySelector('.sticky-navigation--current');
            this.navElInner = navEl.querySelector('.sticky-navigation--mix');

            this.headerElement = document.querySelector('header.wonderful-header');

            let self = this;

            navEl.querySelectorAll('.sticky-navigation--items .sticky-navigation--item').forEach((navItem) => {                
                navItem.addEventListener('click', (event) => {
                    event.preventDefault();
    
                    self.selectItem(navItem);
                });
            });
    
            self.mobileCurrentIndicator.addEventListener('click', (event) => {
                self.toggleNav();
    
                event.stopPropagation();
                event.preventDefault();
            });
        }

        selectItem = (navItem) => {
            let link = navItem.querySelector('a');
            let href = link.getAttribute('href');
        
            let allActive = this.navEl.querySelectorAll('.--active');
        
            allActive.forEach((active) => {
                active.classList.remove('--active');
            });
        
            navItem.classList.add('--active');
        
            if (href.startsWith('#')) {
                let targetLocation = document.querySelector(href);
        
                if (targetLocation) {
                    targetLocation.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
        
                this.toggleNav();
            } else {
                window.location.href = href;
            }
        }
        

        update = () => {
            let rect =  this.navEl.getBoundingClientRect();
            let navHeight = this.headerElement.getBoundingClientRect().height;
            let covidBanner = document.querySelector('#covid-19-info');
            if (navHeight > rect.top) {
                this.navEl.classList.add('--fixed');
                // + 45 is covid banner offset
                this.navElInner.style.top = (covidBanner) ? (navHeight + 40) + 'px' : (navHeight) + 'px';
                
                this.navEl.style.height = rect.height + 'px';
            } else {
                this.navEl.classList.remove('--fixed');
                this.navElInner.style.top = 'inherit';
                this.navEl.style.height = 'unset';
            }
        }

        toggleNav = () => {
            if (window.innerWidth < 992) {
                this.navEl.classList.toggle('mobile-open');
            }
        }
    }

    const stickyNavs = [];

    document.querySelectorAll('.sticky-navigation').forEach((nav) => {
        stickyNavs.push(new StickyNavigation(nav));
    });

    let checkAllNavs = () => {
        stickyNavs.forEach((nav) => {
            nav.update();
        });
    }

    document.addEventListener('scroll', checkAllNavs);
    document.addEventListener('resize', checkAllNavs);

    checkAllNavs();
})();